import { useMemo } from 'react';
import { modelView } from 'effector-factorio';

import { useLocalStorage } from 'shared/hooks/useLocalStorage';
import { FormContainer } from 'shared/ui/FormComponents/FormContainer';

import { Formik } from 'formik';
import { defaultFormValues, FormValues, validationSchema } from '../model';
import { baseLocalStorageKey, factory } from '../model/model';
import { FormView } from './FormView';

export const SurveyForm = modelView(factory, () => {
  const model = factory.useModel();

  const [persistValues] = useLocalStorage<FormValues>(baseLocalStorageKey);

  const initialFormValues = useMemo(() => (persistValues as FormValues) ?? defaultFormValues, [persistValues]);

  const submitForm = (values: FormValues) => {
    model.submitForm(values);
    localStorage.removeItem(baseLocalStorageKey);
  };

  return (
    <FormContainer>
      <Formik
        initialValues={initialFormValues}
        onSubmit={(values) => {
          submitForm(values);
        }}
        validationSchema={validationSchema}
      >
        {({ values, errors }) => <FormView values={values} errors={errors} />}
      </Formik>
    </FormContainer>
  );
});
